const colors = {
    brand: {
        P1: `#D4E5F3`,
        P2: `#9CC1E2`,
        P3: `#669ECD`,
        P4: `#428bca`,
        P5: `#337ab7`,
        P6: `#2e6da4`,
        P7: `#28669B`,
        P8: `#1E527E`,
        P9: `#153D60`,
        S1: `#E1E3E5`,
        S2: `#BABFC3`,
        S3: `#939AA0`,
        S4: `#899197`,
        S5: `#6c757d`,
        S6: `#565e64`,
        S7: `#5A6269`,
        S8: `#484E54`,
        S9: `#353B3F`
    },
    monochrome: {
        MC0: `#ffffff`,
        MC05: `#fafafa`,
        MC1: `#eeeeee`,
        MC2: `#bababa`,
        MC3: `#777777`,
        MC5: `#555555`,
        MC7: `#333333`,
        MC9: `#222222`,
        MC10: `#000000`
    },
    neutral: {
        N0A: `rgba(255, 255, 255, 0.06)`,
        N1A: `rgba(67, 90, 111, 0.04)`,
        N2A: `rgba(67, 90, 111, 0.06)`,
        N3A: `rgba(67, 90, 111, 0.09)`,
        N4A: `rgba(67, 90, 111, 0.14)`,
        N5A: `rgba(67, 90, 111, 0.25)`,
        N6A: `rgba(67, 90, 111, 0.36)`
    },
    scales: {
        // Blue
        B0: `#E3F2FD`,
        B1: `#BBDEFB`,
        B2: `#90CAF9`,
        B3: `#64B5F6`,
        B4: `#42A5F5`,
        B5: `#2196F3`,
        B6: `#1E88E5`,
        B7: `#1976D2`,
        B8: `#1565C0`,
        B9: `#0D47A1`,
        B0A: `rgba()`,
        B1A: `rgba()`,
        B2A: `rgba()`,
        B3A: `rgba()`,
        B4A: `rgba()`,
        B5A: `rgba())`,
        B6A: `rgba()`,
        B7A: `rgba()`,
        B8A: `rgba()`,
        // Green
        G0: `#E8F5E9`,
        G1: `#C8E6C9`,
        G2: `#A5D6A7`,
        G3: `#81C784`,
        G4: `#66BB6A`,
        G5: `#4CAF50`,
        G6: `#43A047`,
        G7: `#388E3C`,
        G8: `#2E7D32`,
        G9: `#1B5E20`,
        G0A: `rgba()`,
        G1A: `rgba()`,
        G2A: `rgba()`,
        G3A: `rgba()`,
        G4A: `rgba()`,
        G5A: `rgba())`,
        G6A: `rgba()`,
        G7A: `rgba()`,
        G8A: `rgba()`,
        // Orange
        O0: `#FFF3E0`,
        O1: `#FFE0B2`,
        O2: `#FFCC80`,
        O3: `#FFB74D`,
        O4: `#FFA726`,
        O5: `#FF9800`,
        O6: `#FB8C00`,
        O7: `#F57C00`,
        O8: `#EF6C00`,
        O9: `#E65100`,
        O10: `#DD2C00`,
        O0A: `rgba()`,
        O1A: `rgba()`,
        O2A: `rgba()`,
        O3A: `rgba()`,
        O4A: `rgba()`,
        O5A: `rgba())`,
        O6A: `rgba()`,
        O7A: `rgba()`,
        O8A: `rgba()`,
        // Purple
        P0: `#F3E5F5`,
        P1: `#E1BEE7`,
        P2: `#CE93D8`,
        P3: `#BA68C8`,
        P4: `#AB47BC`,
        P5: `#9C27B0`,
        P6: `#8E24AA`,
        P7: `#7B1FA2`,
        P8: `#6A1B9A`,
        P9: `#4A148C`,
        P0A: `rgba()`,
        P1A: `rgba()`,
        P2A: `rgba()`,
        P3A: `rgba()`,
        P4A: `rgba()`,
        P5A: `rgba())`,
        P6A: `rgba()`,
        P7A: `rgba()`,
        P8A: `rgba()`,
        // Red
        R0: `#FFEBEE`,
        R1: `#FFCDD2`,
        R2: `#EF9A9A`,
        R3: `#E57373`,
        R4: `#EF5350`,
        R5: `#F44336`,
        R6: `#E53935`,
        R7: `#D32F2F`,
        R8: `#C62828`,
        R9: `#B71C1C`,
        R0A: `rgba()`,
        R1A: `rgba()`,
        R2A: `rgba()`,
        R3A: `rgba()`,
        R4A: `rgba()`,
        R5A: `rgba())`,
        R6A: `rgba()`,
        R7A: `rgba()`,
        R8A: `rgba()`,
        // Yellow (Material Amber)
        Y0: `#FFF8E1`,
        Y1: `#FFECB3`,
        Y2: `#FFE082`,
        Y3: `#FFD54F`,
        Y4: `#FFCA28`,
        Y5: `#FFC107`,
        Y6: `#FFB300`,
        Y7: `#FFA000`,
        Y8: `#FF8F00`,
        Y9: `#FF6F00`,
        Y0A: `rgba()`,
        Y1A: `rgba()`,
        Y2A: `rgba()`,
        Y3A: `rgba()`,
        Y4A: `rgba()`,
        Y5A: `rgba())`,
        Y6A: `rgba()`,
        Y7A: `rgba()`,
        Y8A: `rgba()`
    }
};

const fuzzyColors = {
    background: {
        default: colors.monochrome.MC0,
        tint: colors.monochrome.MC05,
        tintAlt: colors.monochrome.MC1,
        field: colors.monochrome.MC1
    },
    border: {
        default: colors.neutral.N4A,
        muted: colors.neutral.N3A
    },
    fixed: {
        black: colors.monochrome.MC10,
        white: colors.monochrome.MC0
    },
    icons: {
        default: colors.monochrome.MC5,
        muted: colors.monochrome.MC2,
        disabled: colors.neutral.N6A,
        selected: colors.brand.P5
    },
    intent: {
        brand: colors.brand.P5,
        success: `#5cb85c`,
        info: `#5bc0de`,
        warning: `#f0ad4e`,
        danger: `#d9534f`,
        muted: colors.monochrome.MC5
    },
    text: {
        default: colors.monochrome.MC7,
        dark: colors.monochrome.MC9,
        muted: colors.monochrome.MC5,
        link: colors.scales.B9
    }
};

export default {
    ...colors,
    ...fuzzyColors
};
